module.exports = __webpack_public_path__ + "img/PathTrainers.2114aa06.svg";